export default [
  {
    path: '/wallet',
    name: 'wallet',
    component: () => import(/* webpackChunkName: "wallet" */ './wallet/wallet.vue'),
    meta: {
      menuCode: 'pcWallet',
      menuName: '电子钱包',
    },
  },
  {
    path: '/wallet-detail',
    name: 'wallet-detail',
    component: () => import(/* webpackChunkName: "wallet-detail" */ './wallet/wallet-detail.vue'),
    meta: {
      noCache: true,
      menuName: '电子钱包详情',
    },
  },
  {
    path: '/order-detail',
    name: 'order-detail',
    component: () => import(/* webpackChunkName: "order-detail" */ './order/order-details.vue'),
    meta: {
      // menuCode: 'pcWallet',
    },
  },
  {
    path: '/order-management',
    name: 'orderManagement',
    component: () => import(/* webpackChunkName: "order-management" */ './order/order-management.vue'),
    meta: {
      // menuCode: 'pcWallet',
    },
  },
  {
    path: '/order-list',
    name: 'order-list',
    component: () => import(/* webpackChunkName: "order-list" */ './order/order-list.vue'),
    meta: {
      menuCode: 'pcOrderDetail',
      menuName: '订单明细',
    },
  },
  {
    path: '/order-payment-detail',
    name: 'order-payment-detail',
    component: () => import(/* webpackChunkName: "order-payment-detail" */ './order/order-payment-detail.vue'),
    meta: {},
  },
  // 课消记录
  {
    path: '/course-cost-record',
    name: 'course-cost-record',
    component: () => import(
      /* webpackChunkName: "course-cost-record" */ './course-cost-record/course-cost-record.vue'
    ),
    meta: {
      menuCode: 'pcCourseConsumeReport',
      menuName: '课消记录',
    },
  },
  // 收费管家
  {
    path: '/fee-manage',
    name: 'fee-manage',
    component: () => import(/* webpackChunkName: "material-manage" */ './fee-manage/fee-manage.vue'),
    meta: {
      menuCode: 'pcFeeMange',
      menuName: '收费管家',
    },
  },
  // 收支明细
  {
    path: '/revenue-refund',
    name: 'revenue-refund',
    component: () => import(/* webpackChunkName: "revenue-refund" */ './revenue-refund/revenue-refund.vue'),
    meta: {
      menuCode: 'pcPayDetail',
      menuName: '收支明细',
    },
  },
  // 储值卡资金统计
  {
    path: '/stored-card-money',
    name: 'stored-card-money',
    component: () => import(/* webpackChunkName: "stored-card-money" */ './stored-card/index.vue'),
    meta: {
      menuCode: 'storedCardMoney',
      menuName: '储值卡资金',
    },
  },
  // 报名收费
  {
    path: '/registration-fee',
    name: 'registration-fee',
    component: () => import(/* webpackChunkName: "registrationFee" */ './registration-fee/registration-fee.vue'),
    meta: {
      menuCode: 'pcRegistrationFee',
      menuName: '报名收费',
    },
  },
  // 报名收费-支付结果页
  {
    path: '/registration-fee-results',
    name: 'registration-fee-results',
    component: () => import(/* webpackChunkName: "registrationFeeResults" */ './registration-fee/registration-fee-results.vue'),
    meta: {},
  },
];
